import { Response_WorkDetailCreator } from '@/api/@types'
import { CardCreator } from '@/components/common/DataDisplay'

type ActorAndCreatorProps = {
  creators: Response_WorkDetailCreator[] | undefined
}

export const ActorAndCreator = ({ creators }: ActorAndCreatorProps) => {
  return (
    <section aria-labelledby="creator-and-creator" className="pt-16 pb-32">
      <h2 id="creator-and-creator" className="text-md font-bold">
        出演・制作クリエイター
      </h2>
      <div className="flex mt-16 space-x-16">
        {creators?.map(creator => (
          <CardCreator
            id={creator?.id ?? ''}
            key={creator.id}
            variantSize="sm"
            imgSrc={creator?.iconImageUrl ?? '/dummyUser.png'}
            alt={creator?.name ?? ''}
            personName={creator.name}
            roleName={creator.role}
          />
        ))}
      </div>
    </section>
  )
}
